/**
 * Deterministic string hash for seeding render-time randomness.
 * Used to create stable per-feature seeds without external state.
 */
export function fnv1a(input: string): number {
    let h = 0x811c9dc5;
    for (let i = 0; i < input.length; i += 1) {
        h ^= input.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return h >>> 0;
}
